<template>
  <el-dialog title="图片" :visible.sync="showDialog" append-to-body width="30%">
    <img :src="src" alt="">
  </el-dialog>
</template>

<script>
export default {
  // props: {
  //   url: {
  //     type: String,
  //     required: true
  //   }
  // },
  data() {
    return {
      src: '',
      showDialog: false
    }
  },
  methods: {
    open(src) {
      this.src = src;
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    }
  }
}
</script>
<style scoped>
img{
  width: 100%;
}
</style>